import useSWR from 'swr';

import request from '@/utils/request';

export type RecallCampaignStatus =
  | 'draft'
  | 'scheduled'
  | 'running'
  | 'completed'
  | 'cancelled';

export type RecallCampaign = {
  id: number;
  created_at: number;
  updated_at: number;
  name: string;
  subject: string;
  body_text: string;
  body_html: string;
  image_url: string;
  test_email: string;
  emails_per_hour: number;
  status: RecallCampaignStatus;
  target_count: number;
  queued_count: number;
  failed_count: number;
  last_error: string;
  last_dispatch_at: number;
  tested_at: number;
  start_at: number;
  started_at: number;
  completed_at: number;
  cancelled_at: number;
};

export type RecallCampaignSaveReq = {
  name: string;
  subject: string;
  body_text: string;
  body_html: string;
  image_url: string;
  test_email?: string;
  emails_per_hour: number;
  start_at?: number;
};

export type RecallCampaignSummary = {
  current?: RecallCampaign;
  estimated_recipients: number;
  unsubscribed_count: number;
  history: RecallCampaign[];
};

export type RecallCampaignActionResp = {
  campaign: RecallCampaign;
  message: string;
};

export const useRecallCampaignSummary = () => {
  const apiUrl = '/answer/admin/api/recall-campaigns/summary';
  const { data, error, mutate } = useSWR<RecallCampaignSummary, Error>(
    [apiUrl],
    request.instance.get,
  );
  return { data, error, mutate, isLoading: !data && !error };
};

export const saveRecallCampaignDraft = (params: RecallCampaignSaveReq) =>
  request.post<RecallCampaignActionResp>(
    '/answer/admin/api/recall-campaigns/draft',
    params,
  );

export const sendRecallCampaignTest = (
  params: RecallCampaignSaveReq & { test_email: string },
) =>
  request.post<RecallCampaignActionResp>(
    '/answer/admin/api/recall-campaigns/test',
    params,
  );

export const activateRecallCampaign = (id: number, startAt?: number) =>
  request.post<RecallCampaignActionResp>(
    '/answer/admin/api/recall-campaigns/activate',
    { id, start_at: startAt || 0 },
  );

export const cancelRecallCampaign = (id: number) =>
  request.post<RecallCampaignActionResp>(
    '/answer/admin/api/recall-campaigns/cancel',
    { id },
  );

export const recallCampaignRecipientsExportURL =
  '/answer/admin/api/recall-campaigns/recipients/export';
